export default "__VITE_ASSET__c6056b03__"